// Unified tracker: fires Facebook Pixel + TikTok Pixel with a single call.
// Handles event-name mapping between platforms.
import { trackEvent as fbqTrack } from "./facebookPixel";
import { trackTikTokEvent } from "./tiktokPixel";

// Facebook event name -> TikTok event name (when they differ)
const TIKTOK_EVENT_MAP = {
  Lead: "SubmitForm",
  PageView: null, // handled automatically by ttq.page()
};

/**
 * Track an event on Facebook Pixel AND TikTok Pixel simultaneously.
 * @param {string} event - Facebook-style event name (Lead, Contact, ViewContent, InitiateCheckout, ...)
 * @param {object} params - Optional content params (content_name, content_category, ...)
 */
export const track = (event, params = {}) => {
  // Facebook Pixel
  fbqTrack(event, params);

  // TikTok Pixel — map Facebook event name to TikTok convention when needed
  const tiktokEvent = event in TIKTOK_EVENT_MAP ? TIKTOK_EVENT_MAP[event] : event;
  if (tiktokEvent) {
    // TikTok supports similar content parameter names
    trackTikTokEvent(tiktokEvent, params);
  }
};

// Alias for backward compatibility with previous `trackEvent` usage
export const trackEvent = track;
